import { render } from "./TestQuestion.vue?vue&type=template&id=b430198e&ts=true"
import script from "./TestQuestion.vue?vue&type=script&lang=ts"
export * from "./TestQuestion.vue?vue&type=script&lang=ts"

import exportComponent from "/mnt/d/work-ui/iclicker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__